<template>
  <div
    ref="container"
    class="horizontal-scroll-container hscroller"
    :class="{ hscroller_vertical: isVertical }"
    @wheel.stop="e => wheelScroll(e)"
  >
    <div
      v-if="!isVertical"
      class="hscroller_arrow hscroller_arrow_left"
      :class="{ hscroller_arrow_visible: left }"
      :data-tst="`${tstPrefix}_arrow_left`"
      @mouseover="constantScroll(-1)"
      @mouseout="clearScrollInterval"
    >
      <i
        v-show="!noArrow"
        class="mdi mdi-chevron-left icon_btn hscroller_arrow_icon"
        style="
          --after-opacity: var(--arrow-back-opacity);
          height: 100%;
          --after-radius: var(--arrow-after-radius-left);
        "
        @click="scroll(-100)"
      />
    </div>

    <div
      :id="innerId"
      ref="inner"
      :class="innerCssClass"
      class="hscroller_inner text-noselect no-scroll-track"
      @mousemove="handleMousemove"
      @mousedown="handleMousedown"
      @mouseup="handleMouseup"
      @mouseleave="handleMouseleave"
      @scroll="debounceCheckOverflow"
    >
      <slot />
    </div>
    <slot name="after"></slot>

    <div
      v-if="!isVertical"
      class="hscroller_arrow hscroller_arrow_right"
      :class="{ hscroller_arrow_visible: right }"
      :data-tst="`${tstPrefix}_arrow_right`"
      @mouseover="constantScroll(1)"
      @mouseout="clearScrollInterval"
    >
      <i
        v-show="!noArrow"
        class="mdi mdi-chevron-right icon_btn hscroller_arrow_icon"
        style="
          --after-opacity: var(--arrow-back-opacity);
          height: 100%;
          --after-radius: var(--arrow-after-radius-right);
        "
        @click="scroll(100)"
      />
    </div>

    <div
      v-if="isVertical"
      class="hscroller_vertical_close"
      @click.stop="$emit('close:vertical')"
    >
      <i class="mdi mdi-chevron-up icon_btn" />
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import throttle from 'lodash/throttle'

// import HorizolnalScroller from '@/components/HorizolnalScroller/HorizolnalScroller'
// import swipe_mix from '@/mixins/swipe_mix'
// https://youtu.be/p3_xN2Zp1TY?t=318
// scroll-snap-type
// scroll-paddinge

export default {
  name: 'HorizolnalScroller',
  props: {
    innerCssClass: [String, Object],
    innerId: String,
    hasDragscroll: { type: Boolean, default: true },
    hasArrowsMinWidth: { default: () => 1025 },
    watchActionId: { default: () => 'horizontal_scroll_check' },
    isVertical: { default: () => false },
    speed: { default: 2 },
    tstPrefix: { default: () => 'hs' },
  },
  emits: ['close:vertical'],
  data() {
    return {
      scrollInterval: 0,
      scrollTimeout: 0,
      left: false,
      right: false,

      mousedown: false,
      startX: 0,
      innerScrollLeft: 0,
    }
  },
  mounted() {
    nextTick(() => {
      this.checkOverflow()
      this.checkAction()
    })
  },
  methods: {
    debounceCheckOverflow: throttle(function () {
      this.checkOverflow()
    }, 44),
    checkOverflow() {
      this.left = false
      this.right = false
      const { inner } = this.$refs
      if (inner) {
        const { scrollWidth, clientWidth } = inner
        if (clientWidth < scrollWidth && inner) {
          this.left = inner.scrollLeft !== 0
          this.right = scrollWidth - 1 > inner.scrollLeft + clientWidth
        }
      }
    },
    constantScroll(num) {
      if (this.noArrow) return
      this.clearScrollInterval()
      this.scrollTimeout = setTimeout(() => {
        this.scrollInterval = setInterval(() => {
          this.scroll(num * this.speed)
        }, 1)
      }, 50)
    },
    wheelScroll(e) {
      if (this.isVertical) return
      if (!this.left && e.deltaY < 0) return
      if (!this.right && e.deltaY > 0) return
      this.mousedown = false
      e.preventDefault()
      // console.log('wheelScroll', e)
      const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX
      this.scroll(delta)
    },
    scroll(num) {
      // console.log('scroll', num)
      const { inner } = this.$refs
      inner.scrollLeft += num
    },
    clearScrollInterval() {
      clearTimeout(this.scrollTimeout)
      clearInterval(this.scrollInterval)
    },
    checkAction() {
      if (this.globals_action === this.watchActionId) {
        this.$store.dispatch('globals_action', '')
        nextTick(() => {
          this.checkOverflow()
        })
      }
    },
    handleMousedown(e) {
      // console.log('handleMousedown', e)

      if (!this.hasDragscroll) return
      const { inner } = this.$refs
      this.startX = e.pageX - inner.offsetLeft
      this.innerScrollLeft = inner.scrollLeft
      this.mousedown = true
    },
    handleMousemove(e) {
      // console.log('mousemove', e)
      if (this.mousedown) {
        e.preventDefault()
        const { inner } = this.$refs
        const x = e.pageX - inner.offsetLeft
        const walk = (x - this.startX) * 1.5
        const scrollLeft = this.innerScrollLeft - walk
        inner.scrollLeft = scrollLeft
      }
    },
    handleMouseup() {
      this.mousedown = false
      this.clearScrollInterval()
    },
    handleMouseleave() {
      this.mousedown = false
      this.clearScrollInterval()
    },
  },
  computed: {
    noArrow() {
      return this.globals_window_size.width < this.hasArrowsMinWidth
    },
    mdAndDown() {
      return this.$store.getters.globals_mobile
    },
    globals_window_size() {
      return this.$store.getters.globals_window_size
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
    focusMode() {
      return this.$store.getters.focus_mode
    },
  },
  watch: {
    globals_window_size() {
      this.checkOverflow()
    },
    focusMode() {
      setTimeout(() => {
        this.checkOverflow()
      }, 222)
    },
    globals_action() {
      this.checkAction()
    },
  },
}
</script>

<style lang="scss" scoped>
.hscroller {
  position: relative;
  width: 100%;
  min-width: 0;

  --clr-arrow-back: var(--clr-black-0);
  --hscroller-align-items: flex-start;
  --hscroller-radius: 0px;

  --hscroller-inner-overflow-x: auto;
  --hscroller-inner-overflow-y: hidden;

  --arrow-height: 100%;
  --arrow-width: 2em;
  --arrow-size: 2em;
  --arrow-inset: 0 auto auto auto;
  --arrow-left-inset: auto;
  --arrow-right-inset: auto;
  --arrow-after-radius-left: 4px;
  --arrow-after-radius-right: 4px;
  --clr-arrow: var(--clr-white-0);
  --arrow-back-opacity: 1;

  --clr-back: transparent;
  --vertical-height: var(--vh-14);
  &_inner {
    overflow-x: var(--hscroller-inner-overflow-x);
    overflow-y: var(--hscroller-inner-overflow-y);
    position: relative;
    width: 100%;
    top: var(--hscroller-inner-top);
    border-radius: var(--hscroller-radius);
    // display: flex; // carefull use this carefully and check all layouts
    align-items: var(--hscroller-align-items);
  }
  &_vertical {
    --inner-height: var(--vertical-height);
    background: var(--clr-back);
    border-radius: 8px;
    overflow: hidden;
    // padding-top: 1rem;
    &_close {
      position: absolute;
      z-index: 3;
      bottom: 0;
      width: 100%;
      height: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 2em;
      background: var(--clr-arrow-back);
      box-shadow: 0px -1rem 1rem -0.6rem var(--clr-arrow-back);
    }
    .hscroller {
      &_inner {
        overflow-x: hidden;
        overflow-y: auto;
        position: relative;
        width: 100%;
        z-index: 1;
        top: var(--hscroller-inner-top);
        max-height: var(--inner-height);
        padding-bottom: 3rem;
      }
    }
  }
  &_arrow {
    position: absolute;
    z-index: 2;
    height: var(--arrow-height);
    width: var(--arrow-width);
    color: var(--clr-arrow);
    inset: var(--arrow-inset);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: -1;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.44s;
    &_visible {
      opacity: 1;
      z-index: 5;
    }
    &::before {
      height: 100%;
      content: '';
      position: absolute;
    }
    .hscroller_arrow_icon {
      color: var(--clr-white-0);
      position: relative;
      font-size: clamp(1.5rem, var(--arrow-size), 4rem);
    }
    &_left {
      left: -1px;
      .hscroller_arrow_icon {
        inset: var(--arrow-left-inset);
      }
      border-radius: var(--hscroller-radius);
      background: linear-gradient(90deg, var(--clr-arrow-back) 8%, transparent);
    }
    &_right {
      right: -1px;
      .hscroller_arrow_icon {
        inset: var(--arrow-right-inset);
      }
      border-radius: var(--hscroller-radius);

      background: linear-gradient(90deg, transparent, var(--clr-arrow-back) 92%);
    }
  }
}
</style>
